
import { Injectable } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

@Injectable({
    providedIn: SharedModule
})
export class StorageService {
    constructor() {}

    setItem(key: string, value: any) {
        localStorage.setItem(key, value);
    }

    getItem(key: string, defaultValue?: any) {
        const storedValue = localStorage.getItem(key);
        return storedValue ? storedValue : defaultValue;
    }

    removeItem(key: string): void {
        try {
        localStorage.removeItem(key);
        } catch (error) {
        console.error('Error removing item from localStorage:', error);
        }
    }

    hasItem(key: string): boolean {
        try {
        return localStorage.getItem(key) !== null;
        } catch (error) {
        console.error('Error checking localStorage item:', error);
        return false;
        }
    }

    clearItem() {
        localStorage.clear();
    }
}
